// src/components/auth/Register.js
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Register = () => {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }
    try {
      setError("");
      await signup(email, password, { firstName, lastName, company });
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      // Vérifier le code d'erreur Firebase
      if (err.code === "auth/email-already-in-use") {
        setError("Vous avez déjà un compte. Veuillez vous connecter.");
      } else {
        setError("Échec de la création du compte");
      }
    }
  };

  return (
    <div className="max-w-md mx-auto my-16 p-8 bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Créer un compte</h2>
      {error && <div className="mb-4 text-red-600 text-center">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Prénom</label>
          <input
            type="text"
            className="w-full border rounded px-3 py-2"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Votre prénom"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Nom</label>
          <input
            type="text"
            className="w-full border rounded px-3 py-2"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Votre nom"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Entreprise</label>
          <input
            type="text"
            className="w-full border rounded px-3 py-2"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            placeholder="Nom de votre entreprise"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Email</label>
          <input
            type="email"
            className="w-full border rounded px-3 py-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre.email@example.com"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Mot de passe</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••••••"
            required
          />
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 mb-1">Confirmer le mot de passe</label>
          <input
            type="password"
            className="w-full border rounded px-3 py-2"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="••••••••••••"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
        >
          Créer un compte
        </button>
      </form>
      <p className="mt-4 text-center">
        Déjà un compte ?{" "}
        <Link to="/login" className="text-blue-600 hover:underline">
          Se connecter
        </Link>
      </p>
    </div>
  );
};

export default Register;
